<template>
	<div class="error-container">
		<div class="error alert alert-danger alert-dismissible fade show shadow-dk">
			{{errorMsg}}
			<button v-on:click="close" type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		errorMsg: function(){
			return this.$store.state.error.message;
		}
	},
	methods:{
		close:function(){
			this.$store.dispatch('ERROR_MESSAGE_CLEAR');
		}
	}
}
</script>

<style>
.error-container {
	position:fixed;
	bottom:0;
	left:0;
	right:0;
	padding:1em;
	text-align: center;
	z-index:1060;
}
.desktop .error-container{
	left:55px;
}
.error{
	width:100%;
	margin:0;
}
</style>


// WEBPACK FOOTER //
// src/components/error.vue